export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["筛选器"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应用"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除全部"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择状态"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择商店"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入发票号码"])}
}